import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { MapPinIcon, CreditCardIcon, ExternalLinkIcon } from 'lucide-react';
const locations = [{
  name: 'Mitchellville',
  subtitle: 'Main Office',
  address: '10240 Lake Arbor Way',
  cityStateZip: 'Mitchellville, MD 20721',
  paymentUrl: 'https://securepymt.net/?id=HvWDxJeYqN'
}, {
  name: 'Clinton',
  address: '8931 Woodyard Rd',
  cityStateZip: 'Clinton, MD 20735',
  paymentUrl: 'https://securepymt.net/?id=T8VO67Mogl'
}, {
  name: 'Hyattsville',
  address: '1835 University Blvd. Ste 228',
  cityStateZip: 'Hyattsville, MD 20783',
  paymentUrl: 'https://securepymt.net/?id=MMjhEG00Et'
}, {
  name: 'Greenbelt',
  address: '6088 Greenbelt Road Unit 44',
  cityStateZip: 'Greenbelt, MD 20770',
  paymentUrl: 'https://securepymt.net/?id=Vp3GQIjI9a'
}, {
  name: 'Silver Spring',
  address: '8121 Georgia Ave, Ste 800',
  cityStateZip: 'Silver Spring, MD 20910',
  paymentUrl: 'https://securepymt.net/?id=fAWIEGP5iL'
}, {
  name: 'Frederick',
  address: '61 Thomas Johnson Dr, Ste 201',
  cityStateZip: 'Frederick, MD 21702',
  paymentUrl: 'https://securepymt.net/?id=TlJrxDcrlN'
}];
export function PaymentsPage() {
  return <>
      <PageHeader title="Make a Payment" backgroundImage="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1920&q=80" data-id="element-972" />

      <section className="py-20 md:py-28 bg-surface-muted" data-id="element-973">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-974">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-975">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-section-mobile md:text-section text-brand-dark mb-4" data-id="element-976">
              Select Your Location
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-subtitle text-neutral-text/80" data-id="element-977">
              Choose your clinic location below to make a secure online payment.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-978">
            {locations.map((location, index) => <motion.a key={location.name} href={location.paymentUrl} target="_blank" rel="noreferrer" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="group bg-white rounded-card shadow-card border border-gray-100 p-8 flex flex-col items-center text-center hover:shadow-card-hover hover:border-brand-gold/30 transition-all duration-300 focus-ring" data-id="element-979">
                <div className="w-14 h-14 rounded-full bg-brand-gold/10 flex items-center justify-center mb-5 group-hover:bg-brand-gold/20 transition-colors" data-id="element-980">
                  <CreditCardIcon className="w-7 h-7 text-brand-gold" data-id="element-981" />
                </div>

                <h3 className="text-xl font-heading font-bold text-brand-dark mb-1" data-id="element-982">
                  {location.name}
                </h3>

                {location.subtitle && <span className="text-[10px] uppercase font-bold tracking-wider text-brand-gold bg-brand-gold/10 px-2 py-0.5 rounded-sm mb-3" data-id="element-983">
                    {location.subtitle}
                  </span>}

                <div className="flex items-start gap-2 mt-2 mb-6" data-id="element-984">
                  <MapPinIcon className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-985" />
                  <p className="text-sm text-neutral-text/60" data-id="element-986">
                    {location.address}
                    <br data-id="element-987" />
                    {location.cityStateZip}
                  </p>
                </div>

                <div className="mt-auto w-full" data-id="element-988">
                  <span className="flex items-center justify-center gap-2 w-full bg-brand-dark text-white py-3.5 rounded-button font-heading font-semibold group-hover:bg-brand-gold transition-colors" data-id="element-989">
                    Pay Now
                    <ExternalLinkIcon className="w-4 h-4" data-id="element-990" />
                  </span>
                </div>
              </motion.a>)}
          </div>
        </div>
      </section>
    </>;
}